import { styled } from "@mui/material/styles";
import { Divider, Grid } from "@mui/material";
import { getBrandCustom } from "Util/getCustomColor";

export const SummaryTitle = styled("span")({
  fontFamily: "Manrope",
  fontSize: 20,
  fontWeight: 700,
  lineHeight: "28px",
  color: "#465869",
});

export const DividerStyle = styled(Divider, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<{ isMobile: boolean }>(({ isMobile }) => ({
  margin: isMobile ? "16px 0" : "0 16px",
  height: isMobile ? "1px" : "",
}));

export const ContainerStackTaskDates = styled(Grid)({
  backgroundColor: getBrandCustom("headerBackgroundColor", "#EDF5FB"),
  borderRadius: "12px",
  padding: "16px 24px 0 24px",
  marginTop: 16,
});

export const GridItem = styled(Grid)(() => ({
  marginBottom: "16px",
  "@media (max-width: 959px)": {
    marginBottom: 0,
  },
}));
